import { useContext, useEffect, useState } from "react";
import axiosInstance from "../../utilities/Axios";
import AlertDialog from "../AlertDialog/AlertDialog";
import { EDialogAction } from "../Enum/DialogActionEnum";
import JobTitlesDialogBox from "../JobTitles/JobTitlesDialogBox";
import SubAgentDialogBox from "./SubAgentDialogBox";
import { Button, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow } from "@mui/material";
import { LoadingStateContext } from "../../Hooks/LoadingContext/LoadingContext";
import { DeleteOutline, DeleteOutlined, EditOutlined, OpenInNew } from "@mui/icons-material";

const SubAgentTable = (props: { filter: any }) => {
  const [subAgent, setSubAgent] = useState(null);
  const [subAgentList, setSubAgentList] = useState<any[]>([]);
  const [page, setPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [limit, setLimit] = useState(10);
  const [editDialogVisibility, setEditDialogVisibility] = useState(false);
  const [alertDialogVisibility, setAlertDialogVisibility] = useState(false);
  const [dialogAction, setDialogAction] = useState(EDialogAction.view);
  const { changeLoading, isLoading } = useContext(LoadingStateContext);

  useEffect(() => {
    getSubAgentList();
  }, [page, props.filter, limit]);

  const getSubAgentList = async () => {
    changeLoading(true);
    try {
      const response = await axiosInstance.get(`/v1/sub-agents?page=${page}&items_per_page=${limit}`, {
        params: props.filter,
      });

      const data = response.data;
      setSubAgentList(data.result.data);

      setTotalItems(data.result.total);
    } catch (err) {
      console.log(err);
    } finally {
      changeLoading(false);
    }
  };

  const getSubAgentById = async (subAgentId: number, action: EDialogAction) => {
    try {
      const response = await axiosInstance.get(
        `/v1/sub-agents/${subAgentId}`,
        {}
      );

      const data = response.data;

      setSubAgent(data.result);

      if (action == EDialogAction.edit) {
        setEditDialogVisibility(true);
      } else if (action == EDialogAction.view) {
        setEditDialogVisibility(true);
      } else if (action == EDialogAction.delete) {
        setAlertDialogVisibility(true);
      }
      setDialogAction(action);
    } catch (err) {
      console.log(err);
    }
  };

  const goToNextPage = () => {
    setPage(page + 1);
  };

  const goToPreviousPage = () => {
    setPage(page - 1);
  };

  function editDialogClose(action: EDialogAction) {
    setEditDialogVisibility(false);
    if (action == EDialogAction.edit) {
    } else if (action == EDialogAction.view) {
    } else if (action == EDialogAction.delete) {
    }
    getSubAgentList();
  }
  function alertDialogClose(action: EDialogAction) {
    setAlertDialogVisibility(false);
    getSubAgentList();
  }

  return (
    <>
      <SubAgentDialogBox
        open={editDialogVisibility}
        onClose={editDialogClose}
        data={subAgent}
        dialogAction={dialogAction}
      />
      <AlertDialog
        openAlert={alertDialogVisibility}
        onCloseAlert={alertDialogClose}
        data={subAgent}
        action="subAgent"
      />
      <section>
        <TableContainer component={Paper}>
          <Table >
            <TableHead>
              <TableRow>
                <TableCell>Id</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Contact Number</TableCell>
                <TableCell>Actions</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading && <TableRow>
                <TableCell colSpan={4} align="center">
                  <CircularProgress />
                </TableCell>
              </TableRow>}

              {!isLoading && subAgentList.map((data: any, key: number) => {
                return (
                  <TableRow key={data.id}>
                    <TableCell>{data.id}</TableCell>
                    <TableCell>{data.name}</TableCell>
                    <TableCell>{data.contact_no}</TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => {
                          getSubAgentById(data.id, EDialogAction.view);
                        }}
                      >
                        <OpenInNew/>
                      </Button>{" "}
                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        onClick={() => {
                          getSubAgentById(data.id, EDialogAction.edit);
                        }}
                      >
                        <EditOutlined/>
                      </Button>{" "}
                      <Button
                        variant="contained"
                        color="error"
                        size="small"
                        onClick={() => {
                          getSubAgentById(data.id, EDialogAction.delete);
                        }}
                      >
                        <DeleteOutlined/>
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
              {!isLoading && subAgentList.length == 0 && (
                <TableRow>
                  <TableCell colSpan={4} align="center">
                    No data found!
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 15]}
            component="div"
            count={totalItems}
            rowsPerPage={limit}
            page={page}
            onPageChange={(event, newPage) => {
              setPage(newPage);
            }}
            onRowsPerPageChange={(event) => {
              setLimit(parseInt(event.target.value));
              setPage(0);
            }}
          />
        </TableContainer>

      </section>
    </>
  );
};

export default SubAgentTable;
